export const FIELD_EXPLANATIONS = {
  solution_score: {
    titleKey: 'explanations.solutionScore.title',
    contentKey: 'explanations.solutionScore.content',
  },
  startup_match: {
    titleKey: 'explanations.startupMatch.title',
    contentKey: 'explanations.startupMatch.content',
  },
  market_insight_match: {
    titleKey: 'explanations.marketInsightMatch.title',
    contentKey: 'explanations.marketInsightMatch.content',
  },
  startup_search_ranking: {
    titleKey: 'explanations.startupSearchRanking.title',
    contentKey: 'explanations.startupSearchRanking.content',
  },
} as const;

export type ExplanationTopic = keyof typeof FIELD_EXPLANATIONS;

export interface FieldExplanation {
  titleKey: string;
  contentKey: string;
}
